export default __webpack_public_path__ + "static/media/iforfetari2019_def.77204f48.jpg";